import { getAppConfig } from 'app/getConfig';

export const getGTMKey = () => {
  return getAppConfig().REPORT_UI_GTM_KEY;
};
